import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";


export const searchBookUsingIsbnAndOptions = async ({isbn, selectedOptions}) => {
    try {
        const token = getTokenFromSession();
        return await axiosInstance.get(
            `${api.book}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                params: {
                    isbn,
                    options: selectedOptions,
                }
            }
        );
    } catch (error) {
        console.error("Error fetching book details:", error);

        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", "/stockSearch");

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await searchBookUsingIsbnAndOptions({isbn, selectedOptions});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
};


export const saveBookDetails = async ({bookDetails}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.book}`, bookDetails, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
        })
    } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
            const refreshToken = getRefreshToken();
            try {
                sessionStorage.setItem("intendedPage", "/search");
                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                await refreshIdToken(refreshToken);
                await saveBookDetails({bookDetails});
            } catch (refreshError) {
                window.location.href = "/"
            }
        } else {
            console.log(err);
        }
    }
}